import { l as lucia } from "../../../../../chunks/auth.js";
import { p as prisma } from "../../../../../chunks/prisma.js";
import bcrypt from "bcryptjs";
const POST = async ({ request, cookies }) => {
  const { email, password } = await request.json();
  const user = await prisma.user.findUnique({ where: { email } });
  if (!user || !user.password_hash) return new Response(JSON.stringify({ error: "Invalid credentials" }), { status: 401 });
  const ok = await bcrypt.compare(password, user.password_hash);
  if (!ok) return new Response(JSON.stringify({ error: "Invalid credentials" }), { status: 401 });
  const session = await lucia.createSession(user.id, {});
  const sessionCookie = lucia.createSessionCookie(session.id);
  cookies.set(sessionCookie.name, sessionCookie.value, { path: ".", ...sessionCookie.attributes });
  return new Response(JSON.stringify({ ok: true }));
};
export {
  POST
};
